<template>
  <div class="content-center full-height bg-black">
    <div class="p-7 flex justify-center items-center">
      <a href="/"><img src="/images/logo_testo.png" /></a>
    </div>
    <div class="p-2 flex justify-center items-center">
      <span class="text-white text-center font-bold text-2xl">
        Complimenti!<br>La tua registrazione è <br>andata a buon fine.<br><br>Conserva questo codice coupon<br> effettuando uno screenshot e <br>vieni a trovarci nei nostri store
      </span>
    </div>
    <div class="p-1 flex justify-center items-center">
      <vue-barcode style="padding: 20px 20px" v-bind:value="$page.props.flash.success" :options="{ displayValue: true }"></vue-barcode>
    </div>
    <div class="pb-4 flex justify-center items-center">
      <a href="https://streetstock.it/social">
        <button class="btn-indigo sconto-button" type="submit">Torna indietro</button>
      </a>
    </div>
  </div>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'

export default {
  components: {
    VueBarcode,
  },
  data() {
    return {
      options: {},
    }
  },
}
</script>

<style scoped>
/* Imposta il background nero su tutta la pagina */
.full-height {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #000; /* Colore di sfondo nero */
}

/* Impostazioni generali per eliminare margini indesiderati */
body, html {
  margin: 0;
  padding: 0;
  background-color: #000; /* Colore di sfondo per l'intera pagina */
}
</style>
